// 合作要求
import React from 'react'
import styles from './CooperationRequirements.module.scss'
import checkIcon from '@assets/img/check.png'
import { withTranslator } from '@common/hoc/translatorHoc'
import { WithI18nProps } from '@/types/i18n'
import { createAgentI18n } from '@/utils/i18n'

const CooperationRequirements: React.FC<WithI18nProps> = (props) => {
  const { i18n } = props
  const t = React.useMemo(() => createAgentI18n(i18n), [i18n])

  return (
    <section className={styles.section}>
      <h2 className={styles.title}>{t('cooperationRequirements', "合作要求")}</h2>
      <div className={styles.requirementsBox}>
        <div className={styles.item}>
          <img src={checkIcon} alt="check" className={styles.icon} />
          <span className={styles.text}>{t('cooperationRequirementsItem1', "资质要求：境内外合法注册公司")}</span>
        </div>
        <div className={styles.item}>
          <img src={checkIcon} alt="check" className={styles.icon} />
          <span className={styles.text}>{t('cooperationRequirementsItem2', "合作商户数：每区域现有服务商户数≥50家")}</span>
        </div>
        <div className={styles.item}>
          <img src={checkIcon} alt="check" className={styles.icon} />
          <span className={styles.text}>{t('cooperationRequirementsItem3', "行业经验：具备境外餐饮、商超、购物、休闲娱乐商户代运营服务经验优先")}</span>
        </div>
      </div>
    </section>
  )
}

const CooperationRequirementsWithTranslator = withTranslator(CooperationRequirements)
export default CooperationRequirementsWithTranslator
